import { ChatBoxItem } from '@sui/chat-ui'
import { utils } from '@sui/runtime'
import React, { isValidElement, useEffect, useState } from 'react'

function parseEmbedOptions(options) {
    const { welcome: welcomeProp, ...others } = options
    const welcome = typeof welcomeProp === 'function' ? welcomeProp() : welcomeProp
    return {
        ...others,
        welcome: !welcome ? null : (typeof welcome === 'string' ? <div dangerouslySetInnerHTML={{ __html: welcome }}></div> : (isValidElement(welcome) ? welcome : null))
    }
}

export function useEmbedOptions() {
    const [embedOptions, setEmbedOptions] = useState({})
    useEffect(() => {
        try {
            if (typeof window.parent.onGetEmbedChatUIOptions === 'function') {
                const cbHanlder = (options) => {
                    if (typeof options === 'object' && options) {
                        setEmbedOptions(parseEmbedOptions(options))
                    } else {
                        setEmbedOptions({})
                    }
                }
                const options = window.parent.onGetEmbedChatUIOptions(cbHanlder)
                if (utils.isPromiseLike(options)) {
                    options.then(cbHanlder)
                } else if (typeof options === 'object' && options) {
                    cbHanlder(options)
                }
            }
        } catch (error) {

        }
    }, [])
    return embedOptions
}

export default function EmbedWelcome(props) {
    const { children, ...others } = props
    return (
        <ChatBoxItem {...others}>
            {children}
        </ChatBoxItem>
    )
}
